import React from 'react';
import { Carousel } from 'react-bootstrap';
import { useHistory } from "react-router-dom";


import bgImage1 from '../img/explainer/si-handaxe.png';
import bgImage2 from '../img/explainer/si-speartip.png';
import bgImage3 from '../img/explainer/si-glass.png';
import bgImage4 from '../img/explainer/si-porcelain.png';
import bgImage5 from '../img/explainer/si-dom.png';
import bgImage6 from '../img/explainer/si-transistor.png';
import bgImage7 from '../img/explainer/si-areogel.png';


const CarouselContainerSilicon = () => {

  let history = useHistory();

    const  Next= () => {
        setTimeout(() => { history.push("/play/timeline/explainer/au"); }, 600);
	};

    return (
        <Carousel>

  <Carousel.Item interval={30000}> 
    <img
      className="d-block w-100"
      src={bgImage1}
      alt="First slide"
    />
    <Carousel.Caption>
      <h3>Pazúrikový pästný klin</h3>
      <p>Človek sa naučil používať kremík v podobe jeho chemických zlúčenín (nástroje z pazúrika SiO2) min. 500 000 pnl., teda oveľa skôr ako začal používať reč. (cca 150 000 – 100 000 pnl.)</p>
    </Carousel.Caption>
  </Carousel.Item>

  <Carousel.Item interval={30000}> 
    <img
      className="d-block w-100"
      src={bgImage2}
      alt="Second slide"
    />
    <Carousel.Caption>
      <h3>Obsidiánový hrot oštepu</h3>
      <p>Tento hrot je vyrobený z obsidiánu, čo je druh sopečného skla s významným podielom SiO2. Obsidián vzniká vtedy, keď sa dostane žeravá láva do kontaktu s vodou v dôsledku čoho je rýchlo ochladená. Najstarší archeologický nález obsidiánového nástroja spadá do Mezopotámie obdobia 7000 rokov pnl.</p>
    </Carousel.Caption>
  </Carousel.Item>

  <Carousel.Item interval={30000}>
    <img
      className="d-block w-100"
      src={bgImage3}
      alt="Third slide"
    />
    <Carousel.Caption>
      <h3>Prvé sklo</h3>
      <p>Sklo je jeden z najbežnejšie využívaných materiálov na báze oxidu kremičitého. Sklo bolo objavené okolo roku 3000 pred Kr. v Egypte.
</p>
    </Carousel.Caption>
  </Carousel.Item>

  <Carousel.Item interval={30000}>
    <img
      className="d-block w-100"
      src={bgImage4}
      alt="Third slide"
    />
    <Carousel.Caption>
      <h3>Porcelán</h3>
      <p>Cyril a Metod by teoreticky mohli popíjať z porcelánovej šálky. Porcelán je starší. V číne bol známy cca od 7 stor. Porcelán sa vyrába z kaolínu, ktorej hlavnou zložkou je minerál kaolinit - Si2Al2O5(OH4).   Kaolín vznikol zvetraním živcov z hornín, ako je napríklad žula.
</p>
    </Carousel.Caption>
  </Carousel.Item>

  <Carousel.Item interval={30000}>
    <img
      className="d-block w-100"
      src={bgImage5}
      alt="Third slide"
    />
    <Carousel.Caption>
      <h3>Dóm sv. Alžbety v Košiciach</h3>
      <p>Začiatok výstavby najvýznamnejšej katedrály na Slovensku - dómu sv. Alžbety v Košiciach, bol koniec 14. storočia. Stavebným materiálom bol pieskovec. 
</p>
    </Carousel.Caption>
  </Carousel.Item>

  <Carousel.Item interval={30000}>
    <img
      className="d-block w-100"
      src={bgImage6}
      alt="Third slide"
    />
    <Carousel.Caption>
      <h3>Prvé kremíkové tranzistory</h3>
      <p>Od 60-tych rokov 20. storočia sa stal kremík najdôležitejším prvkom sveta polovodičov a tým aj elektroniky. Prvý unipolárny tranzistor na báze kremíka bol vyrobený až v roku 1960 po objavení MOS (metal-oxide-semiconductor).
</p>
    </Carousel.Caption>
  </Carousel.Item>

  <Carousel.Item interval={30000}>
    <img
      className="d-block w-100"
      src={bgImage7}
      alt="Third slide"
    />
    <Carousel.Caption>
      <h3>Aerogél</h3>
      <p>Kremíkový aerogél je látka na kremíkovej báze často nazývaná zamrznutý dym alebo modrý dym. Obsahuje 99,8% vzduchu a vyzerá ako pevná pena s hustotou 3 mg na cm3, čo je najmenšia hustota pevnej látky na svete. Sonda Stardust bola vypustená NASA v r. 1999.
</p>
    <div className='next-btn-container'>
      <button className='next-btn' onClick={() => Next()}>Další level</button>
    </div>
    

    </Carousel.Caption>
  </Carousel.Item>



</Carousel>

    )
}

export default CarouselContainerSilicon;